<template lang="pug">
    crud-form(
        :fields="fields"
        ref="refAbsenceRequestForm"
        submitText="Crear"
        @submitForm="submitCreateAbsenceRequest"
        )
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import { mapActions, mapState } from 'vuex'
import FieldsAbsenceRequest from './FieldsAbsenceRequest'
import EmployeeService from '@/services/api/employee'
import { fetchAll, createAbsenceRequest } from '@/services/api/absenceRequest'
export default {
    name: 'absence-request-create',
    // props: {},
    data: function() {
        return {
            fields: FieldsAbsenceRequest,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        submitCreateAbsenceRequest: async function() {
            let all = this.$refs.refAbsenceRequestForm.vmodels
            let response = await createAbsenceRequest(all)
            this.getResponse(response)
        },
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        getResponse: function(response) {
            switch (response.status) {
                case 'error':
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.error || response.message
                    )
                    break
                case 'success':
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Solicitud de ausencia creada con éxito'
                    )
                    this.$router.push('/absence_request')
                    break
                default:
                    break
            }
        },
        // -- Other functions
        backPreviousView: function() {
            window.history.back()
        },
        setFieldOptionsData(index, data) {
            this.fields[index].options.data = data
        },
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount: async function() {
        this.setFieldOptionsData(0, await EmployeeService.fetchAll())
        this.setFieldOptionsData(1, await fetchAll())
    },
    mounted: function() {
        this.setTitleTopBar('Crear solicitud de ausencia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_ABSENCE_REQUEST')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>